module.exports = __webpack_public_path__ + "img/2.b39ce5d7.jpg";